import { PageHeader } from '@/components/PageHeader';
import { PageLoading } from '@/components';
import { Button } from '@predoc/cow';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router';
import { EditUserModal } from './EditUserModal';
import { useGetUserById } from '../hooks/usersApi';
import { usePageTitle } from '@/hooks';
import { ROLES } from '../constants';

export const UserProfilePage = () => {
  const { userId } = useParams();
  const { data: user, isLoading } = useGetUserById(userId ?? '');
  const navigate = useNavigate();
  usePageTitle('User');

  if (isLoading) {
    return <PageLoading />;
  }

  if (!user) {
    return <div>User not found</div>;
  }

  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader className="pl-4">
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="icon" onClick={handleGoBack}>
            <ArrowLeft className="size-4" />
          </Button>
          <div>
            <h6 className="text-muted-foreground text-sm">Users</h6>
            <h1 className="text-3xl font-bold">{`${user.firstName} ${user.lastName}`}</h1>
          </div>
        </div>

        {user.canBeEdited && (
          <div className="flex items-center gap-2">
            <EditUserModal user={user} />
          </div>
        )}
      </PageHeader>

      <div className="mx-auto max-w-5xl px-4 py-8">
        <div className="grid grid-cols-3 gap-x-8 gap-y-8 rounded-lg border bg-white p-8">
          <div>
            <div className="mb-1 text-sm font-semibold">First Name</div>
            <div>{user.firstName}</div>
          </div>
          <div>
            <div className="mb-1 text-sm font-semibold">Last Name</div>
            <div>{user.lastName}</div>
          </div>
          <div>
            <div className="mb-1 text-sm font-semibold">Email Address</div>
            <div>{user.emailAddress}</div>
          </div>
          <div>
            <div className="mb-1 text-sm font-semibold">Role</div>
            <div>
              {ROLES.find((r) => r.value === user.role)?.label ?? user.role}
            </div>
          </div>
          <div>
            <div className="mb-1 text-sm font-semibold">Profile Access</div>
            <div>
              {user.profileAccess?.map((p) => p.name).join(', ') ?? 'N/A'}
            </div>
          </div>
          <div>
            <div className="mb-1 text-sm font-semibold">Provider Type</div>
            <div>{user.providerType ?? 'N/A'}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
